<template>
  <div class="channelRecord dialRecord">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-custoMersmanage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">拨打记录管理</span>
            </div>
          </div>
          <div class="custoMersmanage-container">
            <div class="content" style="padding-top: 0">
              <div class="flex-wrap pl20 pr20 mt12">
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">意向星级：</span>
                  <div class="rate-box flex-al">
                    <el-rate
                      v-model="client_levelvalue"
                      @change="searchLevel"
                      class="client-level-rate level-rate-fliter"
                      :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                      void-icon-class="crm-like"
                      :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                    ></el-rate>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">拨打时间：</span>
                  <div class="select-box dialRecord-data" style="width: 280px">
                    <el-date-picker
                      v-model="selectForm.rang_time"
                      type="daterange"
                      @change="search"
                      :range-separator="
                        $t(
                          'views.Analysisreport.channelCrmDetailReport.51h4yx8fmf00'
                        )
                      "
                      value-format="yyyy-MM-dd"
                      :start-placeholder="
                        $t(
                          'views.Analysisreport.channelCrmDetailReport.51h4yx8fmzw0'
                        )
                      "
                      :end-placeholder="
                        $t(
                          'views.Analysisreport.channelCrmDetailReport.51h4yx8fnis0'
                        )
                      "
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      v-model="selectForm.outcall_call_type"
                      class="select-mini"
                      style="width: 150px"
                      @change="search"
                      placeholder="请选择联系类型"
                      clearable
                    >
                      <el-option label="拨入" value="IN"></el-option>
                      <el-option label="拨出" value="OUT"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      v-model="selectForm.client_tracestatus"
                      class="select-mini"
                      style="width: 150px"
                      clearable
                      placeholder="请选择客户状态"
                      @change="search"
                    >
                      <el-option
                        v-for="item in clientOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      style="width: 380px"
                      placeholder="可检索中英文名、电话号码、意向课程信息"
                      class="input-cont"
                      v-model="selectForm.keyword"
                      @change="search"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    style="margin-right: 0px"
                    @click="search"
                    >{{ $t("Customersmanage.an") }}</el-button
                  >
                </div>
              </div>

              <div class="pl20 pr20">
                <div
                  class="table-list"
                  style="position: relative"
                  ref="auto_height_table"
                >
                  <levelTableCont
                    :tableData="tableList"
                    @handleColumnChange="handleColumnChange"
                  >
                  </levelTableCont>
                </div>
                <!-- 分页 -->
                <el-pagination
                  style="margin-top: 20px"
                  :current-page.sync="paging.curPage"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size.sync="paging.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="paging.pageTotal"
                  @current-change="curPageChange"
                  @size-change="pageSizeChange"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>
    <!-- 侧边新建栏 -->
    <!-- 侧边栏 -->
    <SliderBox
      :showSliderBox="showSliderBox"
      :sliderWidth="sliderWidth"
      @hideSliderBox="showSliderBox = false"
    >
      <userCreate
        :showUserSliderBox="showSliderBox"
        :Userlist="Userlistcreate"
        :isCustomer="true"
        :clientOption="clientOption"
        :SchoolsourceOption="SchoolsourceOption"
        :chiefPerson="chiefPerson"
        :SchoolCourseOption="SchoolCourseOption"
        :isrepeat="isrepeat"
        :repeatList="repeatList"
        :FamilyRelation="FamilyRelation"
        @onSubmit="onSubmit"
        @wantToTrack="wantToTrack"
        @hideUserSliderBox="hideSliderBox"
        @checkIntentionClientData="checkIntentionClientData"
      ></userCreate>
    </SliderBox>
    <!-- 侧边栏查看-->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      class="user-seeing-slider"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <userSeeing
        :showUserSliderBox="showSliderBoxSee"
        :createJG="createJG"
        :customerId="customerId"
        :ClassMessage="ClassMessage"
        :isTrack="isTrack"
        :isRoot="isRoot"
        :iscanEdit="false"
        :seeSliderTitle="seeSliderTitle"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @handleSliderClick="handleSliderClick"
        @Clickedit="Clickedit"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
        @emitShowImg="emitShowImg"
        @updateList="updateList"
      ></userSeeing>
    </SliderBox>
    <!-- 侧边栏编辑-->
    <SliderBox
      :showSliderBox="showSliderBoxEdit"
      @hideSliderBox="hideSliderBoxEdit"
      :sliderWidth="sliderWidth"
    >
      <userCreate
        :showUserSliderBox="showSliderBoxEdit"
        :Userlist="Userlistedit"
        @hideUserSliderBox="hideSliderBoxEdit"
        :clientOption="clientOption"
        :SchoolsourceOption="SchoolsourceOption"
        :chiefPerson="chiefPerson"
        :SchoolCourseOption="SchoolCourseOption"
        :isrepeat="isrepeat"
        :isEdit="isEdit"
        :FamilyRelation="FamilyRelation"
        :UserInformation="UserInformation"
        :repeatList="repeatList"
        @onSubmit="oneditSubmit"
        @checkIntentionClientData="checkIntentionClientData"
        @deleteFamily="deleteFamily"
        @deleteCourse="deleteCourse"
        @wantToTrack="wantToTrack"
      ></userCreate>
    </SliderBox>
    <!-- 绑定学员 -->
    <el-dialog
      :title="$t('Customersmanage.aq')"
      :visible.sync="createJG"
      class="tan-binding"
      width="30%"
      :before-close="handleClose"
    >
      <div class="create">
        <el-form label-width="120px" ref="BindstudentFrom" :model="BindstudentFrom">
          <el-form-item :label="$t('Customersmanage.ar')" prop="name"
            :rules="[{ required: true, message: '请选择学员' }]">
            <el-select
              filterable
              v-model="BindstudentFrom.name"
              remote
              :remote-method="remoteMethod"
              :loading="loading"
              style="width: 200px"
              :placeholder="$t('Customersmanage.as')"
            >
              <el-option
                v-for="item in FriendName"
                :key="item.client_id"
                :value="item.client_id"
                :label="item.client_cnname"
              >
                {{ item.client_cnname }}
                <i slot="suffix" class="el-input__icon el-icon-date"></i>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Customersmanage.at')" prop="relation"
            :rules="[{ required: true, message: '请选择绑定关系' }]">
            <el-select
              filterable
              v-model="BindstudentFrom.relation"
              style="width: 200px"
              :placeholder="$t('Customersmanage.au')"
            >
              <el-option
                v-for="item in FriendRelation"
                :key="item.friendrelation_id"
                :value="item.friendrelation_name"
                :label="item.friendrelation_name"
                >{{ item.friendrelation_name }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onBindSubmit()">{{
          $t("Customersmanage.av")
        }}</el-button>
        <!-- <el-button @click="createJG = false">取 消</el-button> -->
      </span>
    </el-dialog>
    <!-- 跟班试听 中间-->
    <auditClass
      :leaningVisible="leaningVisible"
      :auditionGenre="auditionGenre"
      :Auditiontime="Auditiontime"
      @handClickcompare="handClickcompare"
      @handClickcancel="handClickcancel"
      @handleClose="handleCloseLean"
    ></auditClass>
    <!-- 编辑列 -->
    <el-dialog
      :title="$t('Customersmanage.aw')"
      class="setting-column"
      :visible.sync="settingVisible"
      width="450px"
      :before-close="handleClose"
    >
      <el-transfer
        :titles="[$t('Customersmanage.ax'), $t('Customersmanage.ay')]"
        v-model="oprateColumn"
        @change="Changeoprate()"
        :data="data"
      ></el-transfer>
      <div class="oprate">
        <el-button type="primary" size="small" @click="handClickOprate()">{{
          $t("Customersmanage.av")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 不是我的意向客户提示 -->
    <el-dialog
      :title="$t('Customersmanage.az')"
      :visible.sync="TipsVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ TipsText }}!</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="TipsVisible = false">{{
          $t("Customersmanage.av")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 转正学员*****弹框 -->
    <el-dialog
      :title="$t('Customersmanage.ba')"
      :visible.sync="positiveVisable"
      class="tan-binding"
      width="500px"
      :before-close="handleClose"
    >
      <div class="positive-div">
        <el-form
          label-width="120px"
          ref="PositiveFrom"
          :model="PositiveFrom"
          :rules="positiveRules"
        >
          <el-form-item :label="$t('Customersmanage.bb')" prop="student_branch">
            <el-input
              v-model="PositiveFrom.student_branch"
              style="width: 260px"
              :placeholder="$t('Customersmanage.bc')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('Customersmanage.bd')" prop="course_branch">
            <el-select
              filterable
              clearable
              v-model="PositiveFrom.course_branch"
              style="width: 260px"
              :placeholder="$t('Customersmanage.be')"
            >
              <el-option
                v-for="(item, index) in courseBranchList"
                :key="index"
                :value="item.course_branch"
                :label="`${item.course_cnname}(${item.course_branch})`"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('Customersmanage.bf')"
            prop="positivelog_time"
          >
            <el-date-picker
              type="date"
              :placeholder="$t('Customersmanage.bg')"
              v-model="PositiveFrom.positivelog_time"
              style="width: 260px"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Customersmanage.bh')">
            <el-input
              v-model="PositiveFrom.positvelog_note"
              style="width: 260px"
              type="textarea"
              maxlength="50"
              :placeholder="$t('Customersmanage.bi')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onTurnSubmit()">{{
          $t("Customersmanage.av")
        }}</el-button>
        <el-button @click="positiveVisable = false">{{
          $t("Customersmanage.bj")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 转正学员*****弹框 -->
    <el-dialog
      title="申请协助跟踪"
      :visible.sync="showApplyPop"
      class="tan-binding"
      width="600px"
      :before-close="handleClose"
    >
      <div class="positive-div">
        <el-form
          label-width="120px"
          ref="PositiveFrom"
          :model="PositiveFrom"
          :rules="positiveRules"
        >
          <div class="choose-user-row">
            <span class="tit">已选择客户(5):</span>
            <div class="user-content">
              <span
                @click="removeUser(index)"
                v-for="(item, index) in chooseUserList"
                :key="index"
                class="user-content-item"
              >
                张嘉佳 {{ index }}
                <i class="el-icon-circle-close"></i>
              </span>
            </div>
          </div>
          <el-form-item
            :label="$t('Customersmanage.bh')"
            prop="positvelog_note"
          >
            <el-input
              v-model="PositiveFrom.positvelog_note"
              style="width: 260px"
              type="textarea"
              maxlength="50"
              :placeholder="$t('Customersmanage.bi')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onTurnSubmit()">{{
          $t("Customersmanage.av")
        }}</el-button>
        <el-button @click="showApplyPop = false">{{
          $t("Customersmanage.bj")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 删除重复名单提示 -->
    <el-dialog
      :title="$t('Customersmanage.az')"
      :visible.sync="delRepeat"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ $t("Customersmanage.bl") }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delRepeatAction()">{{
          $t("Customersmanage.av")
        }}</el-button>
        <el-button @click="delRepeat = false">{{
          $t("Customersmanage.bk")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 申请变更渠道 -->
    <SliderBox :showSliderBox="showApplyChange" :sliderWidth="minSliderwidth">
      <div class="silder-contain slider-admissionCue slider-top-see">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">申请变更渠道</p>
          <el-button
            type="default"
            class="pull-right"
            @click="showApplyChange = false"
          >
            取消
          </el-button>
          <el-button
            @click="handleApply"
            type="primary"
            class="pull-right mr20"
          >
            确定
          </el-button>
        </div>
        <div class="slider-cont text-1">
          <template v-if="applyChannelRow">
            <div class="apply-channel__desc" v-if="applyChannelRow.status == 1">
              <em class="el-icon-warning mr10"></em>
              该名单来源渠道处于保护期，不可随意更改，申请后审核通过几率不是很大喔～请知晓
            </div>
            <div class="apply-user-pop">
              <div class="user-info__img">
                <img
                  :src="
                    applyChannelRow.client_img ||
                    (applyChannelRow.client_sex == '男'
                      ? require('@/assets/images/default-img-man.png')
                      : require('@/assets/images/default-img-women.png'))
                  "
                  alt=""
                />
              </div>
              <span class="user-info__name"
                >{{ applyChannelRow.client_cnname }}
                <em class="user-tips" v-if="applyChannelRow.status == 1">
                  处于渠道保护期
                </em>
              </span>
            </div>
            <el-form
              :model="applyFormData"
              ref="applyFormRef"
              label-width="120px"
            >
              <el-form-item label="原渠道类型：">
                <el-input
                  disabled
                  style="width: 340px"
                  v-model="applyChannelRow.channel_medianame"
                ></el-input>
              </el-form-item>
              <el-form-item label="原渠道明细：">
                <el-input
                  disabled
                  style="width: 340px"
                  v-model="applyChannelRow.channel_name"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="目标渠道类型："
                prop="frommedia_id"
                :rules="[{ required: true, message: '请选择目标渠道类型' }]"
              >
                <el-select
                  filterable
                  clearable
                  style="width: 340px"
                  placeholder="请选择目标渠道类型"
                  v-model="applyFormData.frommedia_id"
                  @change="applyChannelChange"
                >
                  <el-option
                    v-for="(item, index) in applyFormData.sourceList"
                    :key="index"
                    :label="item.frommedia_name"
                    :value="item.frommedia_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="目标渠道明细："
                prop="channel_id"
                :rules="[{ required: true, message: '请选择目标渠道明细' }]"
              >
                <el-select
                  filterable
                  clearable
                  style="width: 340px"
                  placeholder="请选择目标渠道明细"
                  v-model="applyFormData.channel_id"
                >
                  <el-option
                    v-for="(item, index) in applyFormData.channelList"
                    :key="index"
                    :label="item.channel_name"
                    :value="item.channel_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="变更时间："
                prop="channellog_changetime"
                style="width: 340px"
                :rules="[{ required: true, message: '请选择变更时间' }]"
              >
                <el-date-picker
                  type="date"
                  placeholder="请选择变更时间"
                  value-format="yyyy-MM-dd"
                  v-model="applyFormData.channellog_changetime"
                  style="width: 340px"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                label="上传附件："
                prop="channellog_img"
                style="width: 340px"
              >
                <el-upload
                  class="avatar-uploader"
                  :action="$uploadAction('/Uploading/Picture')"
                  name="ossfile"
                  :data="Uploadeimg"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <div
                    style="
                      height: 100%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      flex-direction: column;
                    "
                  >
                    <img
                      v-if="applyFormData.channellog_img"
                      :src="applyFormData.channellog_img"
                    />
                    <template v-else>
                      <i class="el-icon-plus"></i>
                      <div class="el-upload__text">请上传图片</div>
                    </template>
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item
                label="更改原因："
                prop="reason"
                :rules="[{ required: true, message: '请输入更改原因' }]"
              >
                <el-input
                  type="textarea"
                  :rows="6"
                  style="width: 340px"
                  v-model="applyFormData.reason"
                  placeholder="请输入更改原因"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="紧急程度："
                prop="degree"
                :rules="[{ required: true, message: '请选择紧急程度' }]"
              >
                <el-select
                  filterable
                  clearable
                  style="width: 340px"
                  placeholder="请选择紧急程度"
                  v-model="applyFormData.degree"
                >
                  <el-option
                    v-for="(item, index) in applyFormData.degreeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </template>
          <!--<div class="apply-channel__notice mt20 ml20">
            <em class="el-icon-warning"></em>
            渠道类型及明细没有更改喔～本次申请无效
          </div>-->
        </div>
      </div>
    </SliderBox>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
import levelTableCont from "../../components/tables/levelTableCont.vue";

import SliderBox from "@/components/SliderBox";
import userCreate from "@/components/User/create.vue";
import userSeeing from "@/components/User/seeing.vue";
import auditClass from "@/components/Class/Class.vue";
import storeCustoMersmanage from "./channelRecord.js";
import http from "./custoMersmanage.js";
export default {
  name: "CustoMersmanage-custoMersmanage",
  data() {
    return {
      showImgMask: false,
      showImgUrl: "",
      Uploadeimg: {
        company_id: this.$store.state.COMPANY_ID,
        ossfile: "",
      },
      openMenu: ["3"],
      selectForm: {
        keyword: "",
        track_intention_level: "",
        outcall_call_type: "",
        client_tracestatus: "",
        rang_time: "",
      },
      client_levelvalue: null,
      // 客户状态0待跟踪1持续跟踪2已柜询3已试听4已转正-1无意向
      clientOption: [
        {
          value: "0",
          label: this.$t("Customersmanage.bs"),
        },
        {
          value: "1",
          label: this.$t("Customersmanage.bt"),
        },
        {
          value: "2",
          label: this.$t("Customersmanage.bu"),
        },
        {
          value: "3",
          label: this.$t("Customersmanage.bv"),
        },
        {
          value: "4",
          label: this.$t("Customersmanage.bvN8"),
        },
        //0待跟踪 1持续跟踪 2已柜询 3已试听 6待柜询 7待试听 8未柜询 9未试听 10无意向待审核 -1已确认无意向 -2无效名单 4已转正
        {
          value: "-1",
          label: this.$t("Customersmanage.bvN6"),
        },
        {
          value: "-2",
          label: this.$t("Customersmanage.bvN7"),
        }
      ],
      // 表格数据
      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: 0,
        },
      },
      // 分页
      paging: {
        pageTotal: 10,
        curPage: 1,
        pageSize: 10,
      }, // 分页

      // 意向客户数据
      openMenu: ["3"],
      showTMKTab: false,
      showApplyPop: false, // 申请协助跟踪
      chooseUserList: [{}, {}, {}, {}, {}, {}, {}],
      pageActive: "zero",
      showSliderBox: false,
      showSliderBoxSee: false,
      showSliderBoxEdit: false,
      settingVisible: false,
      positiveVisable: false, //转正学员
      delRepeat: false, //删除重复名单
      leaningVisible: false,
      TipsVisible: false, //不是我的意向客户提示
      iscanEdit: true,
      fullscreenLoading: true, //全屏loading
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      ClassMessage: {}, //选择的试听班级
      data: [],
      isEdit: true,
      createJG: false,
      loading: false,
      seeSliderTitle: "客户详情",
      TipsText: this.$t("Customersmanage.bn"), //不能跟进的提示语
      customerId: "", // 客户id
      isTrack: false, //是否点击跟进
      isRoot: false,

      applyChannelRow: null,
      showApplyChange: false, // 变更渠道显示
      applyFormData: {
        frommedia_id: "",
        frommedia_name: "",
        channellog_changetime: "",
        channellog_img: "",
        sourceList: [], // 渠道类型
        channel_id: "",
        channelList: [], // 渠道明细
        reason: "",
        degree: "",
        degreeList: [
          { label: "低", value: "0" },
          { label: "中", value: "1" },
          { label: "高", value: "2" },
        ],
      },

      //转正学员
      PositiveFrom: {
        student_branch: "", //学生编号
        course_branch: "", //课程编号
        positivelog_time: "", //转正日期
        positvelog_note: "", //转正备注
      },
      clientId: "", //单个客户id
      courseBranchList: [], //课程别列表*****转正学员
      //转正学员*****校验规则
      positiveRules: {
        student_branch: [
          {
            required: true,
            message: this.$t("Customersmanage.bo"),
            trigger: "blur",
          },
        ],
        course_branch: [
          {
            required: true,
            message: this.$t("Customersmanage.bp"),
            trigger: "change",
          },
        ],
        positivelog_time: [
          {
            required: true,
            message: this.$t("Customersmanage.bq"),
            trigger: "change",
          },
        ],
        positvelog_note: [
          {
            required: true,
            message: this.$t("Customersmanage.bq"),
            trigger: "change",
          },
        ],
      },
      //绑定学员
      BindstudentFrom: {
        name: "",
        relation: "",
      },
      intentionLevelList:[],//意向星级注释列表
      //用户基本信息
      UserInformation: [],
      ActivityOption: [],
      fu_chiefPerson: [], //副负责人
      FriendName: [], //用户绑定人员名称
      FriendRelation: [], //用户绑定关系
      followFormid: "",
      layoutVisible: false, //分配
      auditionGenre: "", //试听类型
      Auditiontime: "", //试听时间
      currentPage: 1,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      dialogVisible: false,
      // 招生渠道类型
      SchoolsourceOption: [],
      ChannelOption: [],
      OrderFieldOption: [], //获取意向客户排序字段
      chiefPerson: [], //负责人
      SchoolCourseOption: [], //意向课程
      FamilyRelation: [], //获取家庭亲属关系
      repeatList: [], //重复记录列表
      isrepeat: false,
      input: "",
      select: "",
      imageUrl: "",
      levelNum: 5, //侧边栏个数
      sliderWidth: "700px", //侧边栏宽度
      minSliderwidth: "620px",
      activeName: "first",
      buttonHide: false,
      // 侧边栏 资料建档
      form: {
        chinaeseName: "",
        englishName: "",
        sex: "",
        birthday: "",
        memberNum: "",
        familyClassif: "",
        familyName: "",
        familyPhone: "",
        source: "",
        status: "",
        Introducer: "",
        chiefPerson: "",
        deputyPerson: "",
        class: "",
        classInfo: "",
        textarea: "",
      },
      //多条线索信息
      MultipleClues: [],
      Userlistcreate: {
        containClass: "slider-custoMersmanage",
        sliderTitle: this.$t("Customersmanage.ab"),
      },
      Userlistedit: {
        containClass: "slider-custoMersmanage",
        sliderTitle: this.$t("Customersmanage.bw"),
      },
      options: [],
      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: true, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        errortip: "",
        mutiSelectTwoDisable: true, //是否disable复选框
        isShowPersonInfo: true, //是否显示个人资料保护法标识
        // specialColumns:true//特殊列
      },
      optionscaozuoTmk: {
        mutiSelect: true, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        errortip: "",
        mutiSelectTwoDisable: true, //是否disable复选框
        isShowPersonInfo: true, //是否显示个人资料保护法标识
        // specialColumns:true//特殊列
      },
    };
  },
  components: {
    PageNav,
    levelTableCont,
    SliderBox,
    userCreate,
    auditClass,
    userSeeing,
  },

  created() {
    this.slider = this.$store.state.Slider;
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";

    this.selectForm.rang_time = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getDateStr3(new Date()),
    ];
    
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    if (this.$route.query.client_tracestatus) {
      this.selectForm.client_tracestatus = this.$route.query.client_tracestatus;
    }
    this.dialrecordList();
    this.getSource(); // 获取招生渠道类型
    this.getMarketer(); // 获取招生的负责人
    this.getActivityData(); // 获取活动名称
    this.getIntentCourseData(); // 获取意向课程
    this.getFamilyRelationData(); // 获取家庭亲属关系
    this.getChannelData();
    this.getIntentionLevelList();
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableList.options.tableHeight = this.$Tool.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 92
        );
      }
    });
  },
  watch: {
    showApplyChange(n) {
      if (!n) {
        this.applyFormData.frommedia_id = "";
        this.$refs["applyFormRef"].resetFields();
      }
    },
  },
  methods: {
    updateList () {
      this.dialrecordList();
    },
    dialrecordList() {
      http
        .dialrecordList({
          track_intention_level: this.selectForm.track_intention_level,
          outcall_call_type: this.selectForm.outcall_call_type,
          client_tracestatus: this.selectForm.client_tracestatus,
          starttime: this.selectForm.rang_time
            ? this.selectForm.rang_time[0]
            : "",
          endtime: this.selectForm.rang_time
            ? this.selectForm.rang_time[1]
            : "",
          keyword: this.selectForm.keyword,
          p: this.paging.curPage,
          num: this.paging.pageSize,
          is_count: "1", //是否需要总数
        })
        .then((res) => {
          const body = res.data.data;
          const allnum = body.allnum;
          const { field, list } = body;
          this.tableList.columns = field;
          this.tableList.columns.map((v) => {
            if (v.fieldname == "client_cnname") {
              this.$set(v, "ismethod", true);
            }
            if (v.fieldname == "outcall_playurl") {
              this.$set(v, "isRecord", true);
            }
             if (v.fieldname == "client_tag") {
              this.$set(v, "width", '220px');
            }

          });
          this.paging.pageTotal = Number(allnum) || 0;
          if (res.data.code === 200) {
            this.tableList.list = list;
          } else {
            this.tableList.list = [];
            this.tableList.options.errortip = res.data.msg;
          }
        });
    },
    // 公共->意向星级注释列表->zjc
    getIntentionLevelList() {
      this.$http
        .getIntentionLevelList({
        })
        .then((res) => {
          let  list=res.data.data.list;
          let arr=[];
          list.forEach(e=>{
            arr.push(e.intentlevel_remark)
          })
          this.intentionLevelList = arr;
        });
    },
    search() {
      this.paging.curPage = 1;
      this.dialrecordList();
    },
    searchLevel() {
      if (this.selectForm.track_intention_level == this.client_levelvalue) {
        this.client_levelvalue = null;
        this.selectForm.track_intention_level = "";
      } else {
        this.selectForm.track_intention_level = this.client_levelvalue;
      }
      this.search();
    },
    handleColumnChange(k, v, c) {
      (() => {})(c);
      this.isRoot = false;
      this.activeName = "first";
      this.isTrack = false;
      this.iscanEdit = true;
      this.from_client_id = c.client_id;
      this.customerId = c.client_id; //存储客户ID
      this.getclientOneData(c.client_id);

      this.showSliderBoxSee = true;
    },
    // 页码变化
    curPageChange(v) {
      this.paging.curPage = v;
      this.dialrecordList();
    },
    // pageSize改变
    pageSizeChange() {
      this.paging.curPage = 1;
      this.dialrecordList();
    },

    // 意向客户方法

    emitShowImg(v) {
      this.showImgUrl = v;
      this.showImgMask = true;
    },
    applyChannelChange() {
      this.applyFormData.sourceList.forEach((e) => {
        if (e.frommedia_id == this.applyFormData.frommedia_id) {
          this.frommediaName = e.frommedia_name;
        }
      });
      this.applyFormData.channel_id = "";
      this.getChannel();
    },
    handleApply() {
      this.$refs["applyFormRef"].validate((v) => {
        if (v) {
          this.applyChannelAction();
        } else {
          return false;
        }
      });
    },
    // 申请变更
    applyChannelAction() {
      storeCustoMersmanage
        .applyChannelAction({
          client_id: this.applyChannelRow.client_id,
          from_channel_id: this.applyChannelRow.channel_id,
          to_channel_id: this.applyFormData.channel_id,
          channellog_changetime: this.applyFormData.channellog_changetime,
          channellog_img: this.applyFormData.channellog_img,
          channellog_note: this.applyFormData.reason,
          channellog_level: this.applyFormData.degree,
        })
        .then((res) => {
          const { code, msg } = res.data;
          if (code === 200) {
            this.dialrecordList();
            this.showApplyChange = false;
            this.$message.success(msg);
          } else {
            this.$message.error(msg);
          }
        });
    },
    getSourceApi() {
      this.$http.getSource({}).then((res) => {
        (() => {})(res);
        const { data } = res.data;
        data.list.forEach((e) => {
          if (e.frommedia_name == this.frommediaName) {
            this.applyFormData.frommedia_id = e.frommedia_id;
          }
        });
        this.applyFormData.sourceList = data.list;
        this.getChannel();
      });
    },
    getChannel() {
      this.$http
        .getChannel({
          channel_medianame: this.frommediaName,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.applyFormData.channelList = data.list;
          } else {
            this.applyFormData.channelList = [];
          }
        });
    },
    removeUser(i) {
      this.chooseUserList.splice(i, 1);
    },
    //获取活动名称
    getActivityData() {
      storeCustoMersmanage
        .getActivity({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.ActivityOption = res.data.data.list;
          this.ActivityOption.unshift({
            activity_id: "",
            activity_name: this.$t("Customersmanage.br"),
          });
        });
    },
    //获取招生渠道类型
    getSource() {
      storeCustoMersmanage
        .getSource({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.SchoolsourceOption = res.data.data.list;
          //  this.SchoolsourceOption.unshift(
          //   {
          //     frommedia_id: "", frommedia_name: "不限"
          //   }
          // );
        });
    },
    //获取招生渠道明细
    getChannelData() {
      this.$http
        .getChannel({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.ChannelOption = res.data.data.list;
          // this.ChannelOption.unshift({
          //   channel_id: "",
          //   channel_name: "不限"
          // });
        });
    },
    // 获取招生的负责人
    getMarketer() {
      storeCustoMersmanage
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.chiefPerson = res.data.data.list;
          // this.chiefPerson.unshift(
          //   {
          //     marketer_id: "", marketer_name: "不限"
          //   })
        });
    },
    //获取意向课程
    getIntentCourseData() {
      // SchoolClassOption
      storeCustoMersmanage
        .getIntentCourse({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data);
          this.SchoolCourseOption = res.data.data.list;
          //重置筛选
          // this.SchoolCourseOption.unshift(
          //   {
          //     coursecat_id: "", coursecat_cnname
          //   }
          // );
        });
    },
    // 获取家庭亲属关系
    getFamilyRelationData() {
      storeCustoMersmanage
        .getFamilyRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data);
          this.FamilyRelation = res.data.data.list;
        });
    },
    // 意向客户->CRM获取转正课程
    conversionCourseApi() {
      storeCustoMersmanage
        .conversionCourseApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.courseBranchList = res.data.data;
        });
    },
    // 选择意向星级查询
    handleSelectLevel() {
      if (this.clientLevelNum == this.client_levelvalue) {
        this.client_levelvalue = null;
        this.clientLevelNum = "";
      } else {
        this.clientLevelNum = this.client_levelvalue;
      }
      this.currentPage = 1;
            this.dialrecordList();
    },
    // 新增意向客户
    addIntentionclientData(data) {
      storeCustoMersmanage.addIntentionclient(data).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          // this.current=0;
            this.dialrecordList();
          this.showSliderBox = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 编辑意向客户
    editClientData(data) {
      storeCustoMersmanage.editClient(data).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
            this.dialrecordList();
          this.showSliderBoxEdit = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //编辑时删除家庭信息
    deleteFamily(v) {
      if (v.family_id) {
        storeCustoMersmanage
          .delFamilyRelation({
            marketer_id: this.marketer_id,
            token: this.token,
            company_id: this.company_id,
            school_id: this.school_id,
            family_id: v.family_id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            this.dialrecordList();
              // this.showSliderBox=false;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
      }
    },
    //编辑时删除课程信息
    deleteCourse(v) {
      if (v.intention_id) {
        storeCustoMersmanage
          .delIntentionSource({
            marketer_id: this.marketer_id,
            token: this.token,
            company_id: this.company_id,
            school_id: this.school_id,
            intention_id: v.intention_id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            this.dialrecordList();
              // this.showSliderBox=false;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
      }
    },
    // 获取单个客户的基本信息
    getclientOneData(id) {
      storeCustoMersmanage
        .getclientOne({
          marketer_id: this.marketer_id,
          token: this.token,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.UserInformation = res.data.data.list;
        });
    },
    // 新增时-检测重名
    checkIntentionClientData(val) {
      var id;
      if (this.isEdit) {
        id = this.customerId;
      } else {
        id = "";
      }
      storeCustoMersmanage
        .checkIntentionClient({
          token: this.token,
          marketer_id: this.marketer_id,
          client_cnname: val.client_cnname,
          client_mobile: val.client_mobile,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            this.isrepeat = false;
          } else {
            if (res.data.data.list != undefined) {
              this.isrepeat = true;
              this.repeatList = res.data.data.list;
            }
          }
        });
    },
    // 转为招生有效名单/无意向
    handleClickclueloss(type) {
      // 流转类型 1-转为线索 - 1 转为无意向客户
      (() => {})(this.MultipleClues);
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push(item.client_id);
      });
      storeCustoMersmanage
        .changeIntentionClient({
          marketer_id: this.marketer_id,
          token: this.token,
          client_id: arrMultiple,
          type: type,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.dialrecordList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeCustoMersmanage
        .getFriendRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.FriendRelation = res.data.data.list;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData(keyword) {
      storeCustoMersmanage
        .getClientName({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: keyword,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.FriendName = res.data.data.list;
          this.loading = false;
        });
    },
    // 远程搜索绑定学员的名称
    remoteMethod(query) {
      (() => {})(query);
      if (query !== "") {
        this.loading = true;
        this.getClientNameData(query);
      } else {
        this.FriendName = [];
      }
    },
    //绑定学员提交
    onBindSubmit() {
      // (() => {})(this.BindstudentFrom);
      storeCustoMersmanage
        .bindingClient({
          token: this.token,
          marketer_id: this.marketer_id,
          from_client_id: this.from_client_id,
          to_client_id: this.BindstudentFrom.name,
          binding_friend_relation: this.BindstudentFrom.relation,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.dialrecordList();
            this.createJG = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 绑定学员显示
    studentBinding() {
      this.BindstudentFrom = {
        name: "",
        relation: "",
      }; //数据初始化
      this.getFriendRelationData();
      this.createJG = true;
    },
    //查看点击编辑
    Clickedit() {
      this.showSliderBoxSee = false;
      this.showSliderBoxEdit = true;
      // this.getclientOneData(this.customerId);
    },
    //点击查看
    // handleColumnChange(k, v) {
    //   this.isRoot = false;
    //   this.activeName = "first";
    //   this.isTrack = false;
    //   this.iscanEdit = true;
    //   this.from_client_id = v.client_id;
    //   this.customerId = v.client_id; //存储客户ID
    //   this.getclientOneData(v.client_id);
    //   // this.getclientOneData(v.client_id);
    //   // this.getclientOneTrackData(v.client_id);
    //   // this.getFriendRelationData(v.client_id);
    //   // this.getclientOneInviteData(v.client_id); //柜询记录
    //   // this.getclientOneAuditionData(v.client_id); //试听记录
    //   // this.getBindingClientData(v.client_id);//绑定学员信息
    //   this.showSliderBoxSee = true;
    // },
    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    // 试听类型
    ClickAudition(v) {
      this.auditionGenre = v;
    },
    // 试听时间
    ClickAuditiontime(v) {
      (() => {})(v, 121213);
      this.Auditiontime = v;
    },
    handClickcompare(v) {
      (() => {})(v);
      this.ClassMessage = v;
      this.leaningVisible = false;
    },
    handClickcancel() {
      this.leaningVisible = false;
    },
    handleCloseLean(done) {
      this.$confirm(this.$t("Customersmanage.cb"))
        .then((_) => {
          this.leaningVisible = false;
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    // 转正
    turnPositive(v) {
      (() => {})(v);
      // this.PositiveFrom={
      //   student_branch: "",//学生编号
      //   course_branch: "",//课程编号
      //   positivelog_time: "",//转正日期
      //   positvelog_note: "",//转正备注
      // };//数据清空
      this.conversionCourseApi(); // 意向客户->CRM获取转正课程
      this.positiveVisable = !this.positiveVisable;
      this.PositiveFrom.positvelog_note = "";
      this.clientId = v.client_id;
      if (this.$refs["PositiveFrom"]) {
        this.$refs["PositiveFrom"].resetFields();
      }
    },
    // Crm->删除重复名单
    delRepeatAction() {
      this.$http
        .delRepeatAction({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          client_id: this.clientId,
          postbe_crmlevel: this.postbe_crmlevel,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.dialrecordList();
            this.delRepeat = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    //转正学员提交
    onTurnSubmit() {
      this.$refs["PositiveFrom"].validate((valid) => {
        if (valid) {
          storeCustoMersmanage
            .conversionAction({
              token: this.token,
              marketer_id: this.marketer_id,
              client_id: this.clientId,
              student_branch: this.PositiveFrom.student_branch,
              course_branch: this.PositiveFrom.course_branch,
              positivelog_time: this.PositiveFrom.positivelog_time,
              positvelog_note: this.PositiveFrom.positvelog_note,
            })
            .then((res) => {
              // (() => {})(res.data);
              if (res.data.code === 200) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
            this.dialrecordList();
                this.positiveVisable = false;
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
        } else {
          (() => {})("error submit!!");
          return false;
        }
      });
    },
    // 我要跟进
    handleClick(v) {
      // 判断是否为我的意向客户*** 0 时跟进显示灰色
      if (v.client_forbid == "0") {
        this.TipsVisible = true;
        (() => {})(v);
        if (v.client_tracestatus == "4") {
          this.TipsText = this.$t("Customersmanage.cc");
        } else {
          this.TipsText = this.$t("Customersmanage.cd");
        }
      } else {
        this.isRoot = true;
        this.iscanEdit = false;
        this.isTrack = true; //是否点击我要跟进
        this.from_client_id = v.client_id;
        this.followFormid = v.client_id; //跟进
        this.customerId = v.client_id; //存储客户ID
        this.getclientOneData(v.client_id);
        this.showSliderBoxSee = true;
      }
    },
    //跟进提交
    onFllowSubmit(v) {
      // v.track_intention_level = this.clientLevelNum.length;
      v.token = this.token;
      v.marketer_id = this.marketer_id;
      v.school_id = this.school_id;
      v.company_id = this.company_id;
      if (this.followFormid != "") {
        v.client_id = this.followFormid;
      }
      if (v.track_followmode != "") {
        storeCustoMersmanage.settingtrackClient(v).then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.dialrecordList();
            this.showSliderBoxSee = false;
            // 数据清空
            // this.ClassMessage={};
          } else {
            // this.isFllowError=true;
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: this.$t("Customersmanage.ce"),
          type: "error",
        });
      }
    },
    // 绑定学员点击跟进
    ClickFloow(v) {
      this.customerId = v.client_id;
    },
    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    hideSliderBox() {
      this.showSliderBox = false;
    },
    hideSliderBoxEdit() {
      this.showSliderBoxEdit = false;
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },
    handleDel() {
      this.dialogVisible = true;
    },
    // 新增意向客户
    onSubmit(value) {
      (() => {})(value);
      value["marketer_id"] = this.marketer_id;
      value["token"] = this.token;
      value["school_id"] = this.school_id;
      value["company_id"] = this.company_id;
      var isnull =
        value.client_cnname != "" &&
        value.client_sex != "" &&
        value.client_mobile != "" &&
        value.main_marketer_id != "";
      if (isnull) {
        this.addIntentionclientData(value);
      } else {
        this.$message({
          message: this.$t("Customersmanage.cg"),
          type: "error",
        });
      }
    },
    //编辑招生意向客户
    oneditSubmit(value) {
      value["marketer_id"] = this.marketer_id;
      value["token"] = this.token;
      value["school_id"] = this.school_id;
      value["company_id"] = this.company_id;
      var isnull =
        value.client_cnname != "" &&
        value.client_sex != "" &&
        value.client_mobile != "";
      if (isnull) {
        this.editClientData(value);
      } else {
        this.$message({
          message: this.$t("Customersmanage.cg"),
          type: "error",
        });
      }
    },
    // 我要跟踪
    wantToTrack(v) {
      this.getclientOneData(v.client_id);
      this.isRoot = true;
      this.iscanEdit = false;
      //  this.showSliderCreateBox=false;
      this.isTrack = true; //是否点击我要跟进
      this.from_client_id = v.client_id;
      this.followFormid = v.client_id; //跟进
      this.customerId = v.client_id; //存储客户ID
      this.getclientOneData(v.client_id);
      this.showSliderBoxSee = true;
    },
    handleSliderClick(v) {
      (() => {})(v), 11111111;
      if (v == "first") {
        this.iscanEdit = true;
        this.getclientOneData(this.customerId);
      } else {
        if (v == "fourth") {
          this.isRoot = true;
          this.iscanEdit = false;
        } else {
          this.iscanEdit = false;
        }
      }
    },
    changeSize() {
      (() => {})("change");
    },
    handleClose(done) {
      this.$confirm(this.$t("Customersmanage.cb"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },

    handleAvatarSuccess(res) {
      if (res.code === 200) {
        this.applyFormData.channellog_img = res.data.picture_imgurl;
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      const isImg = isJPG || isPNG || isGIF;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error(" 上传图片只能是 JPG/PNG/GIF 格式 !");
      }
      if (!isLt2M) {
        this.$message.error(" 上传图片大小不能超过 2MB!");
      }

      return isImg && isLt2M;
    },
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("channelRecord.less");
.channelRecord {
  height: 100vh;
  font-size: 20px;
}
.dialRecord {
  .dialRecord-data {
    .el-input__inner {
      width: 280px !important;
    }
  }
}
</style>
